import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getPurchaseOrderByIdApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const getPurchaseOrderById = createAsyncThunk('getPurchaseOrderById', async (payload) => {
  // console.log('payload', payload);
  return await getPurchaseOrderByIdApi(payload);
});

const getPurchaseOrderByIdSlice = createSlice({
  name: 'getPurchaseOrderById', // Unique Name
  initialState,
  reducers: {
    getPurchaseOrderByIdReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrderById.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(getPurchaseOrderById.fulfilled, (state, action) => {
        const { message = '', data = [], payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(getPurchaseOrderById.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { getPurchaseOrderByIdReset } = getPurchaseOrderByIdSlice.actions;

export default getPurchaseOrderByIdSlice.reducer;
